import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { getErpErrorMessage } from "@modules/erpIntegrations/utils";

import { deletePlanMapOptionService } from "./service";
import { UseDeletePlanMapOptionMutationOptions } from "./types";

export function useDeletePlanMapOptionMutation(
  options?: UseDeletePlanMapOptionMutationOptions
) {
  const { open } = useNotification();

  return useMutation<void, ApiError, number>({
    mutationFn: deletePlanMapOptionService,
    onError: (error) => {
      open?.({
        type: "error",
        message: getErpErrorMessage(error),
      });
    },
    ...options,
  });
}
